<template>
  <div class="table-column-decrypt">
    <span>{{ showText }}</span>
    <span v-if="decryptDto" @click="toggleDecrypt">
        <el-image :src="show?onView:offView" class="el-icon-decrypt"/>
    </span>
  </div>
</template>

<script>
import { decrypt } from "@/api/util";
import onView from '@/assets/el-icon-onView.png'
import offView from '@/assets/el-icon-offView.png'
export default {
    name:'table-column-decrypt',
    props:['decryptDto', 'srcValue'],
    data(){
        return {
            value: '',
            show: false,
            offView,
            onView
        }
    },
    computed: {
        showText(){
            if (this.decryptDto) {
                return this.show ? this.value : this.decryptDto.showStr
            } else {
                return this.srcValue || ''
            }
        }
    },
    methods: {
        toggleDecrypt(){
            this.show = !this.show;
            if (this.show && !this.value){
               decrypt(this.decryptDto.encStr).then(res =>{
                this.value = res
               })
            }
        },
    }
}
</script>

<style lang="less">
.table-column-decrypt {
    display: inline-flex;
    align-items: center;
    .el-icon-decrypt{
        display: inline-block;
        width: 16px; height: 16px;
        vertical-align: middle;
        overflow: hidden;
        margin-left: 8px;
        cursor: pointer;
    }
}
</style>